<template>
  <span>
    <slot :scope="scope" :name="name">{{formatter?formatter(scope.row[name]):scope.row[name]}}</slot>
  </span>
</template>

<script>
export default {
  props:{
    formatter:Function,
    scope:Object,
    name:String
  }
}
</script>


// WEBPACK FOOTER //
// src/components/tableBody/slotItem.vue